import styled from 'styled-components';

import Section from '../../../Section';

export const Title = styled(Section)`
  margin-top: 200px;
`;
